export enum ObjectType {
  PLAYER = 'player',
  BODYGUARD = 'bodyguard',
  BOMB = 'bomb',
  BULLET = 'bullet',
  CLOUD = 'cloud',
  ENEMY = 'enemy',
  FALLING_OBJECT = 'fallingObject',
  WALL = 'WALL',
  SHOP = 'SHOP',
}
export enum TextTypes {
  SCORE_TEXT = 'SCORE_TEXT',
  PLAYER_HP_TEXT = 'PLAYER_HP_TEXT',
  DEBUG_TEXT = 'DEBUG_TEXT',
  DEATH_TEXT = 'DEATH_TEXT',
  PAUSE_TEXT = 'PAUSE_TEXT',
}
export enum ButtonTypes {
  BOMB = 'BOMB_BUTTON',
  CLOUD = 'CLOUD_BUTTOn',
}
